// @flow
import { SET_BREADCRUMBS } from 'actions';

const initialState = {
  items: []
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_BREADCRUMBS:
      return Object.assign({}, state, { items: action.items });
    default:
      return state;
  }
};

export default reducer;
